namespace $.$$ {
	$mol_style_define($bog_bzrl_app, {
		Head: {
			justify: {
				content: 'space-between',
			},
			align: {
				items: 'center',
			},
			gap: '2rem',
			padding: {
				top: '1rem',
				bottom: '1rem',
				left: '2rem',
				right: '2rem',
			},
			boxShadow: 'none',
		},

		Logo: {
			display: 'flex',
			align: {
				items: 'center',
			},
			gap: '0.5rem',
			background: {
				color: '#f5f5f5',
			},
			border: {
				radius: '2rem',
			},
			padding: {
				top: '0.5rem',
				bottom: '0.5rem',
				left: '1rem',
				right: '1rem',
			},
		},

		Logo_icon: {
			width: '2rem',
			height: '2rem',
		},

		Logo_text: {
			display: 'flex',
			flex: {
				direction: 'column',
			},
			lineHeight: '1.2',
			font: {
				size: '0.9rem',
				weight: 600,
			},
			color: '#333',
			width: 'min-content',
		},

		Actions: {
			display: 'flex',
			align: {
				items: 'center',
			},
			gap: '1rem',
		},

		Body: {
			flex: {
				direction: 'column',
			},
			gap: '3rem',
		},
	})
}
